// extracted by mini-css-extract-plugin
module.exports = {"copy":"_footer_copy__1ucsc","inftabs":"_footer_inftabs__DPE7z","content":"_footer_content__QIIrI","cWrapper":"_footer_cWrapper__1JeEx"};